import { RecExpandedFilterRow } from 'components/DragNDrop/DragNDropRecExpanded';
import { getApiHttpStatus } from 'helpers/rtk-utils';
import { AdminFilter } from 'store/clientFilters/types';
import {
  FILTER_TYPE_OPTIONS,
  getNoCartNotice,
  HDD_CLIENT_ID,
  HDD_NOTICE,
  OATH_CLIENT_ID,
  OATH_NOTICE,
} from './constants';
import { FilterOrderValues } from './types';

export const isNotFoundError = (error: unknown) => getApiHttpStatus(error) === 404;

export const getFiltersNotice = (
  clientId: number | null,
  hasNoCart: boolean,
  clientName?: string
) => {
  if (clientId === OATH_CLIENT_ID) return OATH_NOTICE;
  if (clientId === HDD_CLIENT_ID) return HDD_NOTICE;
  if (hasNoCart) return getNoCartNotice(clientName);
  return null;
};

const describeFilter = ({ filter_type, recipient_ids }: AdminFilter) => {
  const typeLabel =
    FILTER_TYPE_OPTIONS.find(option => option.value === filter_type)?.label ?? filter_type;
  const recipientCount = recipient_ids.length;
  return `${typeLabel} · ${recipientCount} ${recipientCount === 1 ? 'recipient' : 'recipients'}`;
};

export const haveSameFilterOrder = (
  first?: Partial<FilterOrderValues>,
  second?: Partial<FilterOrderValues>
) =>
  first?.filter_ids?.length === second?.filter_ids?.length &&
  (first?.filter_ids ?? []).every((filterId, index) => filterId === second?.filter_ids?.[index]);

/** Rows in `filterIds` order; an id with no matching filter is dropped. */
export const toFilterOrderRows = (
  filters: AdminFilter[],
  filterIds: string[]
): RecExpandedFilterRow[] => {
  const filtersById = new Map(filters.map(filter => [filter.filter_id, filter]));
  return filterIds.flatMap((filterId, index) => {
    const filter = filtersById.get(filterId);
    return filter
      ? [
          {
            value: filterId,
            position: index + 1,
            label: filter.filter_name,
            description: describeFilter(filter),
            isActive: filter.status === 'ACTIVE',
          },
        ]
      : [];
  });
};

export const matchesFilterSearch = (row: RecExpandedFilterRow, search: string) => {
  const query = search.trim().toLowerCase();
  return `${row.label} ${row.description}`.toLowerCase().includes(query);
};
